export enum LumpSumOptions {
  No = 0, //False
  Yes = 1, //True
}
